export const INITIAL_VALUES = {
  date_start: '',
  date_finish: '',
  search: '',
  office_id: null,
  category_id: null,
  group_at: null,
  group_from: null,
};
